import { render } from "./PropertyFilling.vue?vue&type=template&id=20718d64&ts=true"
import script from "./PropertyFilling.vue?vue&type=script&lang=ts"
export * from "./PropertyFilling.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__